export function resolveReplaySampleRate(sampleRateEnv, isProduction) {
  return Number(sampleRateEnv || (isProduction ? '25' : '10'));
}

const isAppProduction = process.env.REACT_APP_ENV === 'production';
const replaySampleRate = resolveReplaySampleRate(
  process.env.REACT_APP_NR_SESSION_REPLAY_SAMPLE_RATE,
  isAppProduction
);

/** Production-only: requires REACT_APP_ENV=production and all NR credentials from Buddy. */
export function isNewRelicEnabled() {
  if (process.env.REACT_APP_ENV !== 'production') return false;
  return Boolean(
    process.env.REACT_APP_NR_LICENSE_KEY &&
      process.env.REACT_APP_NR_APPLICATION_ID &&
      process.env.REACT_APP_NR_ACCOUNT_ID &&
      process.env.REACT_APP_NR_TRUST_KEY &&
      process.env.REACT_APP_NR_AGENT_ID
  );
}

const parseAllowedOrigins = () => {
  const raw = process.env.REACT_APP_NR_ALLOWED_ORIGINS;
  if (raw) {
    return raw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }
  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl) return undefined;
  try {
    return [new URL(apiUrl).origin];
  } catch {
    return undefined;
  }
};

const allowedOrigins = parseAllowedOrigins();

/** Browser ingest license key — set via REACT_APP_NR_LICENSE_KEY (never commit). */
const licenseKey = process.env.REACT_APP_NR_LICENSE_KEY || '';
const applicationID = process.env.REACT_APP_NR_APPLICATION_ID || '';
const accountID = process.env.REACT_APP_NR_ACCOUNT_ID || '';
const trustKey = process.env.REACT_APP_NR_TRUST_KEY || '';
const agentID = process.env.REACT_APP_NR_AGENT_ID || '';

export const newRelicBrowserOptions = {
  init: {
    session_replay: {
      enabled: true,
      // Privacy-safe default: mask all static text; opt out with .nr-unmask / data-nr-unmask
      block_selector: '[data-nr-block], .nr-block',
      mask_text_selector: '*',
      sampling_rate: replaySampleRate,
      error_sampling_rate: 100,
      mask_all_inputs: true,
      collect_fonts: true,
      inline_images: false,
      inline_stylesheet: true,
    },
    distributed_tracing: {
      enabled: true,
      ...(allowedOrigins ? { allowed_origins: allowedOrigins } : {}),
    },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  },
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey,
    applicationID,
    sa: 1,
  },
  loader_config: {
    accountID,
    trustKey,
    agentID,
    licenseKey,
    applicationID,
  },
};

export const NEW_RELIC_PLATFORM_SURFACE = 'web';
